import { render, staticRenderFns } from "./ImgPage.vue?vue&type=template&id=27f23e40&scoped=true&"
import script from "./ImgPage.vue?vue&type=script&lang=ts&"
export * from "./ImgPage.vue?vue&type=script&lang=ts&"
import style0 from "./ImgPage.vue?vue&type=style&index=0&id=27f23e40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f23e40",
  null
  
)

export default component.exports